import { MaskitoOptions } from "@maskito/core";

/**
 * Maskito mask options for a phone number input in the format (XXX) XXX-XXXX
 * @returns Maskito mask options
 * @example
 * (123) 456-7890
 */
export const phoneNumberMask: MaskitoOptions = {
  mask: [
    "(",
    /\d/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ],
};

/**
 * Maskito mask options for multiple area codes in the format (xxx), (xxx), (xxx)
 * @returns Maskito mask options
 * @example
 * (123), (456), (789)
 */
export const areaCodesMask: MaskitoOptions = {
  mask: ({ value }) => {
    // Remove all non-digit characters
    const cleanValue = value.replace(/\D/g, "");

    // If no value, return empty array to allow clearing
    if (!cleanValue) return [];

    const mask: (RegExp | string)[] = [];

    // First area code
    mask.push("(");
    if (cleanValue.length > 0) {
      mask.push(/\d/);
      if (cleanValue.length > 1) {
        mask.push(/\d/);
        if (cleanValue.length > 2) {
          mask.push(/\d/);
          mask.push(")");
        }
      }
    }

    // Second area code - only show after fourth digit
    if (cleanValue.length > 3) {
      mask.push(",");
      mask.push(" ");
      mask.push("(");
      if (cleanValue.length > 3) {
        mask.push(/\d/);
        if (cleanValue.length > 4) {
          mask.push(/\d/);
          if (cleanValue.length > 5) {
            mask.push(/\d/);
            mask.push(")");
          }
        }
      }
    }

    // Third area code - only show after seventh digit
    if (cleanValue.length > 6) {
      mask.push(",");
      mask.push(" ");
      mask.push("(");
      if (cleanValue.length > 6) {
        mask.push(/\d/);
        if (cleanValue.length > 7) {
          mask.push(/\d/);
          if (cleanValue.length > 8) {
            mask.push(/\d/);
            mask.push(")");
          }
        }
      }
    }

    return mask;
  },
};
